import { useContext } from "react"
import { FormProvider, useForm } from "react-hook-form"
import { SEO_SCHEMA } from "~/constants/seo"
import CategoryContext from "~/contexts/Category"
import useSetSeoMutation from "~/hooks/useSetSeoMutation"
import useYupValidationResolver from "~/hooks/useYupValidationResolver"
import SeoContainer from "../../Seo/SeoContainer"
import UnsavedChanges from "../../Seo/UnsavedChanges"

const seoSchema = SEO_SCHEMA

const CategorySeo = () => {
  const { category } = useContext(CategoryContext)
  const { mutateAsync, isLoading } = useSetSeoMutation({
    type: "category",
    type_id: category?.id,
  })

  const onSubmitHandler = async (data) => {
    await mutateAsync(data, methods.reset).then((res) => {
      methods.reset({
        title: res.title ?? "",
        description: res.description ?? "",
        image: res.image ?? "",
      })
    })
  }

  const resolver = useYupValidationResolver(seoSchema)
  const methods = useForm({
    resolver,
    defaultValues: {
      title: category?.seo?.title || "",
      description: category?.seo?.description || "",
      image: category?.seo?.image || {},
    },
  })

  return (
    <FormProvider {...methods}>
      <SeoContainer onSubmitHandler={methods.handleSubmit(onSubmitHandler)} />
      <UnsavedChanges
        onSubmitHandler={methods.handleSubmit(onSubmitHandler)}
        isLoading={isLoading ?? false}
      />
    </FormProvider>
  )
}

export default CategorySeo
